import actions from './actions'

const initialState = {
  isPointRedeemOpen: false,
  totalPoints: 0,
  myPoints: 0,
  tasks: {},
  currentTab: "tasks"
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
